const excludedRedirectPaths = ['/oidc-callback', '/forbidden'];

export function useShortBrowserHistory() {
  return useState<string[]>('shortBrowserHistory', () => (<string[]> JSON.parse(localStorage.getItem('shortBrowserHistory') || '[]')).slice(-2));
}

export function setShortBrowserHistory(path: string) {
  const history = useShortBrowserHistory();
  history.value = [...history.value, path].slice(-2);
  localStorage.setItem('shortBrowserHistory', JSON.stringify(history.value));
}

export function clearShortBrowserHistory() {
  useShortBrowserHistory().value = [];
  localStorage.removeItem('shortBrowserHistory');
}

export function useRedirectPath() {
  return useState<string | null>('redirectPath', () => localStorage.getItem('redirectPath'));
}

export function setRedirectPath(path: string) {
  if (!excludedRedirectPaths.includes(path)) {
    useRedirectPath().value = path;
    localStorage.setItem('redirectPath', path);
  }
}

export function clearRedirectPath() {
  useRedirectPath().value = null;
  localStorage.removeItem('redirectPath');
}

export function navigateToRedirectPathOrDefault() {
  const path = useRedirectPath();
  if (path.value && !excludedRedirectPaths.includes(path.value)) {
    const originalPath = path.value;
    clearRedirectPath();
    console.log(`navigateToRedirectPathOrDefault: redirecting to ${originalPath}`);
    return navigateTo(originalPath);
  } else {
    console.log('navigateToRedirectPathOrDefault: redirecting to default path');
    return navigateTo('/dashboard');
  }
}
